import Big from 'big.js';
import axios, { AxiosResponse } from 'smg/axios';
import Batch from 'smg/batch';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as session from 'smg/customer-api/session';
import { ColumnStats } from 'smg/table/table';
import { DollarFormat } from 'smg/util';
import { Relref } from '../hugo';
import * as payments from '../payments';

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const loader = document.querySelector('#dashboard-loader') as HTMLElement;
    const accountBalance = document.querySelector('#account-balance') as HTMLElement;
    const accountBalanceAmount = accountBalance.querySelector('#account-balance-amount') as HTMLElement;

    const firstTimer = document.querySelector('#first-timer') as HTMLElement;

    const orderHistory = document.querySelector('#order-history') as HTMLElement;
    const orderHistoryCount = orderHistory.querySelector('#order-history-count') as HTMLElement;
    const orderHistoryTotal = orderHistory.querySelector('#order-history-total') as HTMLElement;

    const unpaidEl = document.querySelector('#unpaid') as HTMLElement;
    const unpaidCountEl = unpaidEl.querySelector('#unpaid-count') as HTMLElement;
    const unpaidTotalEl = unpaidEl.querySelector('#unpaid-total') as HTMLElement;
    const unpaidPayEl = unpaidEl.querySelector('#unpaid-pay') as HTMLElement;

    const showCards: HTMLElement[] = [];

    const sess = session.Session();

    void sess.then(sess => {
        if (Big(sess.balance).gt('0')) {
            accountBalanceAmount.textContent = DollarFormat(sess.balance);
            showCards.push(accountBalance);
        }
    });

    const b = new Batch();

    const ordersCount = b.get<ColumnStats>('/orders', {
        params: {
            'colStats': 'id',
        },
    }).then(resp => {
        if (!resp.data.count) {
            return;
        }

        orderHistoryCount.textContent = resp.data.count.toLocaleString();
        showCards.push(orderHistory);
    });

    const ordersTotal = b.get<ColumnStats>('/orders', {
        params: {
            'colStats': 'total',
        },
    }).then(resp => {
        if (!resp.data.sum) {
            return;
        }

        orderHistoryTotal.textContent = DollarFormat(resp.data.sum);
        showCards.push(orderHistory);
    });

    const unpaidParams = {
        'q': 'balance:>=.01',
        'data': 'balance',
        'max': 9999,
    };
    const unpaidOrders = b.get<hyejoo.Orders>('/orders', {
        params: unpaidParams,
    }).then(resp => {
        if (!resp.data.orders.length) {
            return;
        }

        const ids: string[] = [];
        let total = Big('0');

        const consumeResp = (resp: AxiosResponse<hyejoo.Orders>) => {
            total = Big('0');
            for (const order of resp.data.orders) {
                ids.push(order.id ?? '');
                total = total.add(order.balance ?? '');
            }

            unpaidCountEl.textContent = `${resp.data.orders.length.toLocaleString()} ${resp.data.orders.length === 1 ? 'Order' : 'Orders'}`;
            unpaidTotalEl.textContent = DollarFormat(total);
        };

        consumeResp(resp);

        unpaidPayEl.addEventListener('click', async () => payments.PromptPayment(await sess, ids, total, false).
            then(() => axios.get<hyejoo.Orders>('/orders', {
                params: unpaidParams,
            }).then(resp => {
                consumeResp(resp);
                if (total.lt('.01')) {
                    unpaidEl.parentElement?.removeChild(unpaidEl);
                }
            })));

        showCards.push(unpaidEl);
    });

    void b.Exec();

    await sess;
    await ordersCount;
    await ordersTotal;
    await unpaidOrders;

    if (!showCards.length) {
        firstTimer.classList.remove('d-none');
    } else {
        showCards.forEach(el => el.classList.remove('d-none'));
    }

    loader.parentElement?.removeChild(loader);
}